import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  gridItem: {
    maxHeight: 520,
  },
  isLoading: {
    height: 520,
  },
  smallGridItem: {
    maxHeight: 300,
  },
  smallIsLoading: {
    height: 300,
  },
  fixedGridItem: {
    height: 500,
  },
  tableHead: {
    '& th': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
  },
}))
